export default __webpack_public_path__ + "static/media/minde.a4109c85.svg";